import React from "react";
import "./App.css";
import Search from "./Search";
import Timer from "./Timer";

function App() {
  return (
    <div className="App">
      <Search />
      <Timer />
    </div>
  );
}

export default App;
